/** Organization service level tiers; values match `service_level.service_level_id`. */
export const ServiceLevel = {
    Bronze: 1,
    Silver: 2,
    Gold: 3,
} as const;

export type ServiceLevelId = (typeof ServiceLevel)[keyof typeof ServiceLevel];

/** Whether an organization's tier is at least `minimum`; an unknown tier never qualifies. */
export function meetsServiceLevel(level: number | null | undefined, minimum: ServiceLevelId): boolean {
    return level != null && level >= minimum;
}
